// extracted by mini-css-extract-plugin
export default {"modal":"modal__yAcoD","sampleFlowWrapper":"sampleFlowWrapper__1PRZY","lessPadding":"lessPadding__2K0l1"};